<template>
  <div class="culture-page">
    <CultureNav />
    <CultureHero
      title="Places"
      summary="The restaurants, breweries, venues, and gathering spots that have become part of the Reckon story."
      eyebrow="The Reckon Way"
    />
    <main>
      <v-container>
        <section class="section-heading">
          <p>Where It Happened</p>
          <h2>Our Places</h2>
          <span>Each place connects back to the traditions and experiences that brought the crew there.</span>
        </section>
        <div class="card-grid">
          <CultureCard
            v-for="place in places"
            :key="place.id"
            :title="place.name"
            :href="{ name: 'reckon-way-place', params: { placeSlug: place.slug } }"
            :show-image="false"
            eyebrow="Reckon Place"
            :summary="place.description"
            :metadata="metadataFor(place)"
          />
        </div>
      </v-container>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import AppFooter from '@/components/Footer.vue';
import CultureNav from '@/components/reckon-way/culture/CultureNav.vue';
import CultureHero from '@/components/reckon-way/culture/CultureHero.vue';
import CultureCard from '@/components/reckon-way/culture/CultureCard.vue';
import { places } from '@/content/culture/places';

export default {
  name: 'CulturePlacesView',
  components: {
    AppFooter, CultureNav, CultureHero, CultureCard,
  },
  data: () => ({ places }),
  methods: {
    metadataFor(place) {
      return [
        [place.city, place.state].filter(Boolean).join(', '),
        `${place.related.length} related ${place.related.length === 1 ? 'story' : 'stories'}`,
      ].filter(Boolean);
    },
  },
};
</script>

<style scoped>
.culture-page, main { background: #050505; }
.culture-page main { padding: 58px 0 76px; }
.section-heading { margin-bottom: 28px; }
.section-heading p { color: #e23232; font-family: "Oswald", sans-serif; font-size: .8rem; font-weight: 900; margin: 0 0 6px; text-transform: uppercase; }
.section-heading h2 { color: #fff; font-family: "Oswald", sans-serif; font-size: clamp(2rem, 5vw, 3rem); margin: 0 0 10px; }
.section-heading span { color: #aaa; font-size: 1rem; }
.card-grid { display: grid; gap: 16px; grid-template-columns: repeat(auto-fit, minmax(260px, 1fr)); }
</style>
